import { render } from "./ScoreLookup.vue?vue&type=template&id=64dc39f6&scoped=true"
import script from "./ScoreLookup.vue?vue&type=script&lang=js"
export * from "./ScoreLookup.vue?vue&type=script&lang=js"

import "./ScoreLookup.vue?vue&type=style&index=0&id=64dc39f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dc39f6"]])

export default __exports__